import { Timestamp } from '@klear/time'

export const SSE_EVENT_TYPE_KYC_UPDATE = 'kyc_update'
export const SSE_EVENT_TYPE_KLEAR_ACCOUNT_UPDATE = 'klear_account_update'
export const SSE_EVENT_TYPE_CONNECTED = 'connected'
export const SSE_EVENT_TYPE_HEARTBEAT = 'heartbeat'

export const SSE_HEADERS = {
  'Content-Type': 'text/event-stream',
  'Cache-Control': 'no-cache',
  Connection: 'keep-alive'
} as const

export interface SSEMessage {
  type: string
  timestamp: number
}

export interface SSEConnectedMessage extends SSEMessage {
  type: typeof SSE_EVENT_TYPE_CONNECTED
  message: string
}

export interface SSEHeartbeatMessage extends SSEMessage {
  type: typeof SSE_EVENT_TYPE_HEARTBEAT
  timestamp: number
}

export interface SSEUpdateMessage {
  type: string
  organizationId: number
  timestamp: number
}

export interface KlearAccountSSEMessage extends SSEUpdateMessage {
  type: typeof SSE_EVENT_TYPE_KLEAR_ACCOUNT_UPDATE
}

export function generateClientUniqueId(): string {
  return `${Timestamp.timestamp()}-${Math.random().toString(36).substring(2, 8)}`
}

export function createClientId(eventType: string, organizationId: string | number): string {
  const clientUniqueId = generateClientUniqueId()
  return `${eventType}-org-${organizationId}-client-${clientUniqueId}`
}

export function getOrganizationIdFromClientId(clientId: string): number {
  const orgIdMatch = clientId.match(/org-(\d+)-client/)
  if (!orgIdMatch || !orgIdMatch[1]) return -1
  return parseInt(orgIdMatch[1])
}

export function formatSSEMessage(message: SSEMessage): string {
  return `data: ${JSON.stringify(message)}\n\n`
}

export function createConnectedMessage(): SSEConnectedMessage {
  return {
    type: SSE_EVENT_TYPE_CONNECTED,
    message: 'SSE connection established',
    timestamp: Timestamp.timestamp()
  }
}

export function createHeartbeatMessage(): SSEHeartbeatMessage {
  return {
    type: SSE_EVENT_TYPE_HEARTBEAT,
    timestamp: Timestamp.timestamp()
  }
}

export const SSE_HEARTBEAT_INTERVAL = 30000
